import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { UsersModel } from '../../../../core/domainModels/users/UsersModel';
import {
    assignColDefsDefaults,
    COLUMN_WIDTH,
    compareFilterList,
    fieldName,
    filterMenuTab,
} from '../../../../core/helpers/aggrid';
import { TachoColumnState } from '../../../../core/domainModels/displayPreferences/tachoColumnState';
import { ColumnTooltip } from '../../../components/TachoTooltip/columnTooltip';
import { SetFilter } from '../../../components/AgGrid/Filters/SetFilter';

export const usersTableDefaultColumnsDefs: ColDef = {
    sortable: true,
    resizable: true,
    filter: SetFilter,
    filterParams: {
        comparator: compareFilterList,
    },
    tooltipComponent: ColumnTooltip,
    sortingOrder: ['asc', 'desc', null],
    menuTabs: filterMenuTab,
};

export const usersTableColumnsDefinitions = (
    formatMessage: ({ id }: { id: string }) => string,
    defColumnState: Array<TachoColumnState>,
): Array<ColDef> => {
    const columns: Array<ColDef> = [
        {
            colId: '0',
            headerName: '',
            field: 'selected',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            maxWidth: 40,
            minWidth: 40,
        },
        {
            colId: fieldName<UsersModel>('email'),
            headerName: formatMessage({ id: 'usersEmail' }),
            headerTooltip: formatMessage({ id: 'usersEmail' }),
            field: fieldName<UsersModel>('email'),
            initialWidth: COLUMN_WIDTH.XXL,
        },
        {
            colId: fieldName<UsersModel>('roleId'),
            headerName: formatMessage({ id: 'usersRole' }),
            headerTooltip: formatMessage({ id: 'usersRole' }),
            field: fieldName<UsersModel>('roleId'),
            flex: 1,
            valueFormatter: (cellParams: ValueFormatterParams) =>
                cellParams.value === 1 ? formatMessage({ id: 'User' }) : formatMessage({ id: 'Admin' }),
            filterValueGetter: cellParams =>
                cellParams.data.roleId === 1 ? formatMessage({ id: 'User' }) : formatMessage({ id: 'Admin' }),
        },
    ];
    assignColDefsDefaults(columns, defColumnState, true);
    return columns;
};
